import { Color } from '@diritto/common/style/color';
import Avatar from 'boring-avatars';

export const ProfileAvatar = ({ name }: { name?: string }) => (
  <Avatar
    name={name}
    variant="beam"
    colors={[Color.Primary300, Color.Blue500, Color.Blue300, Color.Primary500, Color.Green400]}
  />
);
